import api from "./api";

// Returns the first hostname label (potential subdomain), or null for
// localhost / IP / apex domains where there is no company subdomain.
export function hostSubdomain() {
  const host = window.location.hostname;
  if (/^(localhost|\d+\.\d+\.\d+\.\d+)$/.test(host)) return null;
  const parts = host.split(".");
  if (parts.length < 3) return null; // need sub.domain.tld
  return parts[0].toLowerCase();
}

let _cache;

// Resolves the active company from the current host's subdomain (e.g.
// cleya.example.com -> Cleya Agency). Returns the company brand or null.
export async function resolveHostCompany() {
  if (_cache !== undefined) return _cache;
  try {
    const { data } = await api.get("/public/resolve-company", { params: { host: window.location.host } });
    _cache = data;
  } catch {
    _cache = null;
  }
  return _cache;
}
